import { store } from "..";
import auth from "./auth";

export const hasAccess = (resource, rbac = store?.getState().rootReducer?.rbac) => {
    const roles = auth?.myStatus?.roles;
    if (!roles) return false;
    if (roles.filter(role => role.role === "superadmin").length > 0) {
        return true;
    }
    const ok = roles.find(role => {
        const roleName = role.role;
        if (role.entityType!=="Restaurant")
            return false;
        var res = "";
        for (const r of resource.split(".")) {
            if (r === "*") {
                //eslint-disable-next-line no-loop-func
                if (rbac?._roles?.[roleName] && rbac?._roles?.[roleName]?.permissions.find(r => r.startsWith(res+"."))) {
                    return true;
                }
            }
            //eslint-disable-next-line no-loop-func
            res += (res ? "." : "") + r;
            if (rbac?._roles?.[roleName] && rbac?._roles?.[roleName]?.permissions.find(r => r===res)) {
                return true;
            }
        }
        if (rbac?._roles?.[roleName] && rbac?._roles?.[roleName]?.permissions.find(r => r.startsWith(resource+"."))) {
            return true;
        }
        return false;
    }) != null;
    return ok;
};
